export default "__VITE_ASSET__DalyhWzp__"